import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function formItemProps(field: SchemaField, className?: string): string {
  if (field.height === 'fill' && className) return ` className="flex-1 min-h-0 ${className}"`
  if (field.height === 'fill') return ' className="flex-1 min-h-0"'
  return className ? ` className="${className}"` : ''
}
